module.exports = __webpack_public_path__ + "static/media/hair (9).877df58c.jpg";